<template>
  <div class="page-login">
    <header>
      <div class="content">
        <a href="/"><img src="/images/logo.svg" class="header-logo" /></a>
        <a href="/login" class="header-button-si">Sign In</a>
      </div>
    </header>
    <section class="login">
      <div class="content">
        <div class="login-form">
          <form class="form-horizontal form-material" id="registerform" @submit.prevent="submit" @keydown="registerForm.errors.clear($event.target.name)">
              <h1>Great, let’s start raising capital for you!</h1>
              <p>Add your details, complete our first questionnaire, and we will match you with our investors and we will show you what kind of investor are suitable for your offering and where they are from. This is completely free of charge.</p>

              <label for="first_name">{{ trans('auth.first_name') }}</label>
              <input type="text" name="first_name" v-model="registerForm.first_name" />
              <show-error :form-name="registerForm" prop-name="first_name"></show-error>

              <label for="last_name">{{ trans('auth.last_name') }}</label>
              <input type="text" name="last_name" v-model="registerForm.last_name" />
              <show-error :form-name="registerForm" prop-name="last_name"></show-error>
<!--
              <label for="company">{{ trans('auth.company') }}</label>
              <input type="text" name="company" v-model="registerForm.company" />
              <show-error :form-name="registerForm" prop-name="company"></show-error>
-->
              <label for="email">{{ trans('auth.email') }}</label>
              <input type="text" name="email" v-model="registerForm.email" />
              <show-error :form-name="registerForm" prop-name="email"></show-error>
<!--
              <label for="phone">{{ trans('auth.phone') }}</label>
              <input type="text" name="phone" v-model="registerForm.phone" />
              <show-error :form-name="registerForm" prop-name="phone"></show-error>
-->
              <label for="password">{{ trans('auth.password') }}</label>
              <input type="password" name="password" v-model="registerForm.password" />
              <show-error :form-name="registerForm" prop-name="password"></show-error>

              <label for="password_confirmation">{{ trans('auth.confirm_password') }}</label>
              <input type="password" name="password_confirmation" v-model="registerForm.password_confirmation" />
              <show-error :form-name="registerForm" prop-name="password_confirmation"></show-error>
             <!--  <h3>or sign up with</h3>
              <ul class="login-social">
                <li class="icon-linkedin"><input type="radio" name="social" id="social-linkedin" /><label for="social-linkedin">LinkedIn</label></li>
                <li class="icon-google"><input type="radio" name="social" id="social-google" /><label for="social-google">Google</label></li>
                <li class="icon-microsoft"><input type="radio" name="social" id="social-microsoft" /><label for="social-microsoft">Microsoft</label></li>
              </ul> -->
              <div class="clear"></div>
              <div class="login-form-checkboxes">
                <input type="checkbox" name="terms" id="terms" v-model="registerForm.tnc" />
             <!--   <label for="terms">I agree to PropTechAM.ai’s website <a href="">Terms of Use</a> and <a href="">Privacy Policy</a>.</label>
                <show-error style="margin-top:-20px;margin-bottom:20px;display:block;" :form-name="registerForm" prop-name="tnc"></show-error> -->
                <input type="checkbox" name="newsletter" id="newsletter" v-model="registerForm.newsletter" />
                <label for="newsletter">(Optional) Sign up to our Newsletter (you can unsubscribe at any time).</label>
              </div>
              <button class="button" type="submit">CONTINUE</button>
          </form>
        </div>
        <div class="login-hiw">
          <h2>Here’s how it works</h2>
          <ul>
            <li><i>1</i><h3>Complete our first questionnaire</h3><p>Tell us more about your investor preferences and your investment offering</p></li>
            <li><i>2</i><h3>Get some free, suitable investor insights</h3><p>based on the information submitted</p></li>
            <li><i>3</i><h3>Book a video call with one of our experts</h3><p>Our team will review your offering and give you a quote</p></li>
          </ul>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
  </div>
</template>

<script>
    import guestFooter from '../../layouts/guest-footer.vue'
    import password from 'vue-password-strength-meter'

    export default {
        data() {
            return {
                registerForm: new Form ({
                    email: '',
                    password: '',
                    password_confirmation: '',
                    first_name: '',
                    last_name: '',
                    /* phone: '',
                    company: '', */
                    newsletter: false,
                    tnc: false,
                })
            }
        },
        components: {
            guestFooter,password
        },
        mounted(){
            $("body").addClass("page-register");
            if(!helper.featureAvailable('registration')){
                helper.featureNotAvailableMsg();
                return this.$router.push('/home');
            }
        },
        methods: {
            submit(){
                this.registerForm.post('/api/auth/register')
                    .then(response =>  {
                        toastr.success(response.message);
                        this.$router.push('/login');
                    }).catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getConfig(config){
                return helper.getConfig(config);
            }
        }
    }
</script>
